import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { endpoints } from "../../../../../../../core/defaultValues";
import {
    clientQuery,
} from "../../../../../../../core/data/GraphQLApi";
import { ExceptionManager } from "../../../../../../../core/logManager";

const INIT_STATE = {
    open: false,
    drivers: [],
    scheduledAt: null,
    estimatedDuration: 0,
    selectedDriver: null,
    driverId: null,
    driverName: null,
    driver: null,
    loading: false,
    tagIds: [],
    total: []
};

const route = "modules/workOrders/modals/driverSelector/redux/slice";

export const workOrdersSearchAvailableDrivers = createAsyncThunk(
    "workOrders/workOrdersSettingsSearchWorkOrderTypes/searchAvailableDrivers",
    async ({ dateRange, tagIds, openSearch, limit, offset, reset, excludedWorkOrderIds }, { rejectWithValue }) => {
        try {
            const response = await clientQuery(
                `
                    query ($openSearch: String, $dateRange: AWSDateTimeRange!, $tagIds: [Int], $excludedWorkOrderIds: [Int], $limit: Int, $offset: Int) {
                        data: searchAvailableDrivers(
                            openSearch: $openSearch
                            dateRange: $dateRange
                            tagIds: $tagIds
                            excludedWorkOrderIds: $excludedWorkOrderIds
                            limit: $limit
                            offset: $offset
                        ) {
                            items {
                                id
                                name
                                unitId
                                unitName
                                avatarFileId
                                repositoryPath
                                fileKey
                            }
                            total
                        }
                    }
                `,
                {
                    openSearch,
                    dateRange,
                    tagIds,
                    excludedWorkOrderIds,
                    limit: limit,
                    offset: offset
                },
                endpoints.GRAPHQL_GENERAL_V2
            );

            return { ...response?.data, reset } || { items: [], total: 0 };

        } catch (exc) {
            ExceptionManager(exc, route, "searchAvailableDrivers");
            return rejectWithValue(exc);
        }
    }
);

const workOrdersDriverSelectorRedux = createSlice({
    name: "workOrders/driverSelector",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload
                ? { ...state, ...action.payload }
                : { ...INIT_STATE };
        },
        openModalWorkOrderDriverSelector(state, action) {
            state.open = true;
            state.scheduledAt = action?.payload?.scheduledAt;
            state.estimatedDurationMins = action?.payload?.estimatedDurationMins;
            state.driverId = action?.payload?.driverId;
            state.driverName = action?.payload?.driverId;
            state.driver = action?.payload?.driver;
            state.tagIds = action?.payload?.tagIds;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //workOrdersSearchAvailableDrivers
        builder.addCase(workOrdersSearchAvailableDrivers.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrdersSearchAvailableDrivers.fulfilled, (state, action) => {
            state.loading = false;
            state.drivers = action.payload.reset ? action.payload.items : [...state.drivers, ...action.payload.items];
            state.total = action.payload.total;
        });
        builder.addCase(workOrdersSearchAvailableDrivers.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersDriverSelectorRedux;

// Extract and export each action creator by name
export const {
    reset,
    openModalWorkOrderDriverSelector
} = actions;

// Export the reducer, either as a default or named export
export default reducer;
